var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { SchemaField, complieExpression, FormExpressionScopeContext } from '@formily/react-schema-renderer';
import { toArr, isFn, isArr, FormPath } from '@formily/shared';
import { ArrayList, DragListView } from '@formily/react-shared-components';
import { CircleButton } from '../circle-button';
import { TextButton } from '../text-button';
import { Table, Form } from 'antd';
import { FormItemShallowProvider } from '@formily/antd';
import { PlusOutlined, DeleteOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import styled from 'styled-components';
var ArrayComponents = {
    CircleButton: CircleButton,
    TextButton: TextButton,
    AdditionIcon: function () { return React.createElement(PlusOutlined, { style: { fontSize: 20 } }); },
    RemoveIcon: function () { return React.createElement(DeleteOutlined, null); },
    MoveDownIcon: function () { return React.createElement(DownOutlined, null); },
    MoveUpIcon: function () { return React.createElement(UpOutlined, null); }
};
var DragHandler = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 7px;\n  display: inline-block;\n  height: 14px;\n  border: 2px dotted #c5c5c5;\n  border-top: 0;\n  border-bottom: 0;\n  cursor: move;\n  margin-bottom: 24px;\n"], ["\n  width: 7px;\n  display: inline-block;\n  height: 14px;\n  border: 2px dotted #c5c5c5;\n  border-top: 0;\n  border-bottom: 0;\n  cursor: move;\n  margin-bottom: 24px;\n"])));
export var ArrayTable = styled(function (props) {
    var expressionScope = useContext(FormExpressionScopeContext);
    var value = props.value, schema = props.schema, className = props.className, editable = props.editable, path = props.path, mutators = props.mutators;
    var _a = schema.getExtendsComponentProps() || {}, renderAddition = _a.renderAddition, renderRemove = _a.renderRemove, renderMoveDown = _a.renderMoveDown, renderMoveUp = _a.renderMoveUp, renderEmpty = _a.renderEmpty, renderExtraOperations = _a.renderExtraOperations, operationsWidth = _a.operationsWidth, operations = _a.operations, draggable = _a.draggable, componentProps = __rest(_a, ["renderAddition", "renderRemove", "renderMoveDown", "renderMoveUp", "renderEmpty", "renderExtraOperations", "operationsWidth", "operations", "draggable"]);
    var schemaItems = Array.isArray(schema.items)
        ? schema.items[schema.items.length - 1]
        : schema.items;
    var onAdd = function () {
        if (schemaItems) {
            mutators.push(schemaItems.getEmptyValue());
        }
    };
    var onMove = function (dragIndex, dropIndex) {
        mutators.move(dragIndex, dropIndex);
    };
    var renderColumns = function (items) {
        return items.mapProperties(function (props, key) {
            var itemProps = __assign(__assign({}, props.getExtendsItemProps()), props.getExtendsProps());
            return __assign(__assign({ title: complieExpression(props.title, expressionScope) }, itemProps), { key: key, dataIndex: key, render: function (value, record, index) {
                    var newPath = FormPath.parse(path).concat(index, key);
                    return (React.createElement(FormItemShallowProvider, { key: newPath.toString(), label: undefined, labelCol: undefined, wrapperCol: undefined },
                        React.createElement(SchemaField, { path: newPath, schema: props })));
                } });
        });
    };
    var columns = [];
    if (schema.items) {
        columns = isArr(schema.items)
            ? schema.items.reduce(function (buf, items) {
                return buf.concat(renderColumns(items));
            }, [])
            : renderColumns(schema.items);
    }
    if (editable && operations !== false) {
        columns.push(__assign(__assign({}, operations), { key: 'operations', dataIndex: 'operations', width: operationsWidth || 200, render: function (value, record, index) {
                return (React.createElement(Form.Item, null,
                    React.createElement("div", { className: "array-item-operator" },
                        React.createElement(ArrayList.Remove, { index: index, onClick: function () { return mutators.remove(index); } }),
                        React.createElement(ArrayList.MoveDown, { index: index, onClick: function () { return mutators.moveDown(index); } }),
                        React.createElement(ArrayList.MoveUp, { index: index, onClick: function () { return mutators.moveUp(index); } }),
                        isFn(renderExtraOperations)
                            ? renderExtraOperations(index)
                            : renderExtraOperations)));
            } }));
    }
    if (draggable) {
        columns.unshift({
            width: 20,
            key: 'dragHandler',
            render: function () {
                return React.createElement(DragHandler, { className: "drag-handler" });
            }
        });
    }
    var renderTable = function () {
        return (React.createElement(Table, __assign({}, componentProps, { rowKey: function (record) {
                return toArr(value).indexOf(record);
            }, pagination: false, columns: columns, dataSource: toArr(value) })));
    };
    return (React.createElement("div", { className: className },
        React.createElement(ArrayList, { value: value, minItems: schema.minItems, maxItems: schema.maxItems, editable: editable, components: ArrayComponents, renders: {
                renderAddition: renderAddition,
                renderRemove: renderRemove,
                renderMoveDown: renderMoveDown,
                renderMoveUp: renderMoveUp,
                renderEmpty: renderEmpty
            } },
            draggable ? (React.createElement(DragListView, { onDragEnd: onMove, nodeSelector: "tr.ant-table-row", ignoreSelector: "tr.ant-table-expanded-row" }, renderTable())) : (renderTable()),
            React.createElement(ArrayList.Addition, null, function (_a) {
                var children = _a.children;
                return (children && (React.createElement("div", { className: "array-table-addition", onClick: onAdd }, children)));
            }))));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  margin-bottom: 10px;\n  table {\n    margin-bottom: 0 !important;\n  }\n  .array-table-addition {\n    background: #fbfbfb;\n    cursor: pointer;\n    margin-top: 3px;\n    border-radius: 3px;\n    .next-btn-text {\n      color: #888;\n    }\n    .next-icon:before {\n      width: 16px !important;\n      font-size: 16px !important;\n      margin-right: 5px;\n    }\n  }\n  .ant-btn {\n    color: #888;\n  }\n  .array-item-operator {\n    display: flex;\n    button {\n      margin-right: 8px;\n    }\n  }\n"], ["\n  width: 100%;\n  margin-bottom: 10px;\n  table {\n    margin-bottom: 0 !important;\n  }\n  .array-table-addition {\n    background: #fbfbfb;\n    cursor: pointer;\n    margin-top: 3px;\n    border-radius: 3px;\n    .next-btn-text {\n      color: #888;\n    }\n    .next-icon:before {\n      width: 16px !important;\n      font-size: 16px !important;\n      margin-right: 5px;\n    }\n  }\n  .ant-btn {\n    color: #888;\n  }\n  .array-item-operator {\n    display: flex;\n    button {\n      margin-right: 8px;\n    }\n  }\n"])));
ArrayTable.isFieldComponent = true;
export default ArrayTable;
var templateObject_1, templateObject_2;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd-components/esm/array-table/index.js
// module id = 2096
// module chunks = 0